<header class='govpl'>
  <nav id='gov-menu-nav'>
    <button
      (click)='toggleGovMenuNav()'
      class='govpl__menu-opener'
      aria-controls='gov-menu'
      aria-expanded='false'
      aria-label='Menu główne Pokaż nawigację.'>
      <span class='govpl__menu-opener__hamburger'>
      <span></span>
      <span></span>
      <span></span>
      </span>
    </button>
    <div id='gov-menu' class='govpl-menu'>
      <div class='govpl-menu__container' tabindex='-1'>
        <div class='govpl-menu__section hide-desk'>
          <ul>
            <li>
              <a *ngIf='!authed else isAuthed' hideMenu routerLink='/goto-login-gov' (click)='onLoginSSO()'>
                <i class='gov-icon gov-icon--account'></i>
                <span class='sr-only'>Logowanie do portalu</span>Zaloguj przez Węzeł Krajowy
              </a>
              <ng-template #isAuthed>
                <ng-container *ngIf='tokenData as data'>
                <span class='user-info'>
                  <strong>{{ data?.firstName }} {{ data?.lastName }}</strong>
                  <a hideMenu class='logout-btn' href='/logout' title='Wyloguj'>
                    Wyloguj&nbsp;
                    <i class='fa fa-sign-out-alt'></i>
                  </a>
                </span>
                </ng-container>
              </ng-template>
            </li>
          </ul>
        </div>
        <div class='govpl-menu__section'>
          <ul>
            <li>
              <a hideMenu routerLink='/strona-glowna' routerLinkActive='active'>
                Strona główna <span class='sr-only'>{{ name }}</span>
              </a>
            </li>
            @if (authed) {
              <li>
                <a hideMenu routerLink='/moje-dane' routerLinkActive='active'>
                  Moje dane
                </a>
              </li>
              <li>
                <a hideMenu routerLink="/ustawienia" routerLinkActive='active'>Ustawienia</a>
              </li>
            }
            <li>
              <a hideMenu routerLink='/e-uslugi' routerLinkActive='active'>
                E-usługi
              </a>
            </li>
            <li *ngIf='authed && dataCompleted'>
              <a hideMenu routerLink='/wnioski-robocze' routerLinkActive='active'>
                Wnioski robocze
              </a>
            </li>
            <li *ngIf='authed && dataCompleted'>
              <a hideMenu routerLink='/wnioski-zatwierdzone' routerLinkActive='active'>
                Wnioski zatwierdzone
              </a>
            </li>
            <li *ngIf='authed && dataCompleted'>
              <a hideMenu routerLink='/wnioski-wyslane' routerLinkActive='active'>
                Wnioski wysłane
              </a>
            </li>
            <!--            <li *ngIf='authed && dataCompleted'>-->
            <!--              <a hideMenu routerLink='/moje-sprawy' routerLinkActive='active'>-->
            <!--                Moje sprawy-->
            <!--              </a>-->
            <!--            </li>-->
            <li *ngIf="authed && dataCompleted">
              <a hideMenu routerLink="/konsultacje-spoleczne" routerLinkActive="active">
                Partycypacje społeczne
              </a>
            </li>
            <li>
              <a hideMenu routerLink="/odpady-komunalne" routerLinkActive="active">
                Odpady komunalne
              </a>
            </li>
            <!--            <li>-->
            <!--              <a hideMenu routerLink="/moje-oplaty" routerLinkActive="active">-->
            <!--                Moje opłaty-->
            <!--              </a>-->
            <!--            </li>-->
            <li>
              <a hideMenu routerLink="/zgloszenie/skladanie-wniosku" routerLinkActive="active">
                eUsterka / Zgłoszenie
              </a>
            </li>
            @if (authed) {
              <li>
                <a hideMenu routerLink='/platnosci-online' routerLinkActive='active'>
                  Płatności online
                </a>
              </li>
            }
            <li>
              <a
                title="Link jest otwierany w nowej zakładce przeglądarki"
                target="_blank"
                href="https://dlugoleka.grobonet.com">
                Cmentarze komunalne
              </a>
            </li>
          </ul>
          <hr>
          <ul>
            <li>
              <a hideMenu routerLink="/jak-korzystac" routerLinkActive='active'>
                Jak korzystać
              </a>
            </li>
            <li>
              <a hideMenu routerLink='/info/aplikacja-mobilna' routerLinkActive='active'>
                Aplikacja mobilna
              </a>
            </li>
            <li>
              <a hideMenu routerLink="/info/o-projekcie" routerLinkActive='active'>
                O projekcie
              </a>
            </li>
            <li>
              <a hideMenu routerLink='/info/polityka-prywatnosci' routerLinkActive='active'>
                Polityka prywatności
              </a>
            </li>
            <li>
              <a hideMenu routerLink='/info/regulamin' routerLinkActive='active'>
                Regulamin
              </a>
            </li>
            <li>
              <a hideMenu routerLink='/info/deklaracja-dostepnosci' routerLinkActive='active'>
                Deklaracja dostępności
              </a>
            </li>
            <li>
              <a hideMenu routerLink='/info/kontakt' routerLinkActive='active'>
                Kontakt
              </a>
            </li>
          </ul>
        </div>
        <button class='govpl-menu__close'>Zamknij menu</button>
      </div>
    </div>
  </nav>
  <nav id='top-bar-nav' class='govpl__top-bar'>
    <h1 class='govpl__header'>
      <a [ngStyle]="{ 'background-image': appLogoPath }" class='govpl__logotype govpl-logo' routerLink='/'
         aria-label='Strona główna'>
        <span class='govpl__portal-short-name '>{{ name }}</span>
      </a>
      <span class='govpl__portal-name '>
        <span class='sr-only'>{{ name }}</span>
        {{ desc }}
      </span>
    </h1>
    <ng-container *ngIf='!authed'>
      @if (!production) {
        <a class='govpl__panel-login btn btn-secondary' routerLink='/obtain_token'>
          <span class='sr-only'>Logowanie do portalu</span>&nbsp;Zaloguj jako demo
        </a>
      }
      <a class='govpl__panel-login btn btn-secondary' routerLink='/goto-login-gov' (click)='onLoginSSO()'>
        <span class='sr-only'>Logowanie do portalu</span>&nbsp;Zaloguj przez Węzeł Krajowy
      </a>
    </ng-container>
    <ng-container *ngIf='authed'>
      <ng-container *ngIf='tokenData as data'>
        <span class='govpl__panel-login user-info'>
          Witaj:&nbsp;<strong>{{ data?.firstName }} {{ data?.lastName }}</strong>
          <a class='logout-btn' href='/logout' title='Wyloguj'><i class='fa fa-sign-out-alt'></i></a>
        </span>
      </ng-container>
    </ng-container>
    <ng-container *ngIf='showUELogo'>
      <span class='govpl__separator'></span>
      <img src='/img/icons/eu/eu-center-pl.svg' class='govpl__eu-logo' alt='Logotyp Unii Europejskiej'>
    </ng-container>
  </nav>
</header>
